import { render, staticRenderFns } from "./BlacklistActivity.vue?vue&type=template&id=5a850556&scoped=true&"
import script from "./BlacklistActivity.vue?vue&type=script&lang=js&"
export * from "./BlacklistActivity.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistActivity.vue?vue&type=style&index=0&id=5a850556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a850556",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VSelect,VTextField})
